import {NavLink, useLocation, useParams} from 'react-router-dom';
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	NavigationMenuTrigger,
	navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu.tsx';
type SectionLink = {to: string; label: string};

const ANALYTICS: SectionLink[] = [
	{to: 'analytics/unit', label: 'Unit-экономика'},
	{to: 'analytics/sales', label: 'Продажи'},
	{to: 'analytics/stocks', label: 'Остатки'},
	{to: 'analytics/runs', label: 'Анализы'},
];

const COMPETITORS: SectionLink[] = [
	{to: 'competitors', label: 'Сводка'},
	{to: 'competitors/comparison', label: 'Сравнение'},
	{to: 'competitors/manage', label: 'Управление конкурентами'},
];

function productBase(offerId: string): string {
	return `/ozon/products/${encodeURIComponent(offerId)}`;
}

export function ProductNav() {
	const {offerId = ''} = useParams();
	const {pathname, search} = useLocation();
	const base = productBase(offerId);
	const overviewActive = pathname === base;
	const analyticsActive = pathname.startsWith(`${base}/analytics`);
	const competitorsActive = pathname.startsWith(`${base}/competitors`);

	return (
		<>
			<div className="md:hidden">
				<NavigationMenu>
					<NavigationMenuList>
						<NavigationMenuItem>
							<NavigationMenuTrigger>Разделы</NavigationMenuTrigger>
							<NavigationMenuContent className="w-64">
								<div className="flex flex-col gap-1">
									<SectionLinks items={[{to: base, label: 'Обзор'}]} search={search}/>
									<p className="px-3 pt-2 text-sm text-muted-foreground">Аналитика</p>
									<SectionLinks items={ANALYTICS.map((item) => ({...item, to: `${base}/${item.to}`}))} search={search}/>
									<p className="px-3 pt-2 text-sm text-muted-foreground">Конкуренты</p>
									<SectionLinks items={COMPETITORS.map((item) => ({...item, to: `${base}/${item.to}`}))} search={search}/>
								</div>
							</NavigationMenuContent>
						</NavigationMenuItem>
					</NavigationMenuList>
				</NavigationMenu>
			</div>
			<div className="hidden md:block">
				<NavigationMenu>
					<NavigationMenuList className="justify-start">
						<NavigationMenuItem>
							<NavigationMenuLink
								active={overviewActive}
								className={navigationMenuTriggerStyle()}
								render={<NavLink to={{pathname: base, search}} end/>}
							>
								Обзор
							</NavigationMenuLink>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuTrigger data-active={analyticsActive ? 'true' : undefined} className="data-[active=true]:bg-muted">
								Аналитика
							</NavigationMenuTrigger>
							<NavigationMenuContent className="w-56">
								<SectionLinks items={ANALYTICS.map((item) => ({...item, to: `${base}/${item.to}`}))} search={search}/>
							</NavigationMenuContent>
						</NavigationMenuItem>
						<NavigationMenuItem>
							<NavigationMenuTrigger data-active={competitorsActive ? 'true' : undefined} className="data-[active=true]:bg-muted">
								Конкуренты
							</NavigationMenuTrigger>
							<NavigationMenuContent className="w-72">
								<SectionLinks items={COMPETITORS.map((item) => ({...item, to: `${base}/${item.to}`}))} search={search}/>
							</NavigationMenuContent>
						</NavigationMenuItem>
					</NavigationMenuList>
				</NavigationMenu>
			</div>
		</>
	);
}

function SectionLinks({items, search}: {items: SectionLink[]; search: string}) {
	return (
		<div className="flex flex-col">
			{items.map((item) => (
				<NavigationMenuLink key={item.to} render={<NavLink to={{pathname: item.to, search}} end/>}>
					{item.label}
				</NavigationMenuLink>
			))}
		</div>
	);
}
